<template>
  <div class="container info-container">
    <h1>Exclusive Center Spots on the Pixel Wall</h1>
    <h2>$XBANK – The Fuel Behind the Pixel Wall</h2>
    <p>
      Everyone on the XRP Pixel Wall is a legend, but certain spots offer a unique chance to cement your legacy alongside the greatest names in XRPL like David Schwartz and Brad Garlinghouse. We have 8 prime locations at the very center of the wall now available for purchase.
      <br>
      <br>
      A portion of the proceeds from these sales will be used for a buyback and burn of $XBANK tokens, directly benefiting the entire Pixel Wall community.
      <br>
      <br>
      To secure one of these exclusive spots on the Pixel Wall, a minimum area of 5x5 squares is available for 625 XRP. If you're interested in customizing your size or specific location, please contact us directly through our <a style="color: white;" href="https://x.com/Millionpixelxrp" target="_blank">X profile</a>.
      <br>
      <br>
      Are you ready to etch your name among the titans of XRP and become a legend in the crypto world?
    </p>
  </div>
</template>

<script>
export default {
  name: 'CenterSpotsPage'
}
</script>

<style scoped>
</style>
